import type { ReactNode } from 'react'
import { Form } from '@/components/Form'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { ErrorBlock } from '@/components/ErrorBlock'

export interface CreateAmendmentDialogProps {
  showing: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  isSubmitPending: boolean
  isSubmitRejected: boolean
  submitError?: unknown
  onSubmitErrorClose: () => unknown
  children?: ReactNode
}

export function CreateAmendmentDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  isSubmitRejected,
  submitError,
  onSubmitErrorClose,
  children,
}: CreateAmendmentDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>New Amendment</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            If the Client wants additional service, the Pro for reasons wants
            more earnings, or the Client wants a refund or reduced services, you
            can add amendments to the job here.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        <ModalSheetContentBlock>
          <Form onSubmit={onSubmit}>{children}</Form>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      {isSubmitRejected && (
        <ErrorBlock
          tackOn="bottom"
          error={submitError}
          onClose={onSubmitErrorClose}
        />
      )}

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            isDisabled={isSubmitPending}
            onPress={onClose}
            testId="add-amendment-close-button"
          />
          <Button
            label="Save"
            variant="primary"
            onPress={onSubmit}
            isPending={isSubmitPending}
            testId="add-amendment-submit-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
